module.exports = __webpack_public_path__ + "img/technology-logo.e2c25b32.png";